var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5469 21.0938C16.3718 21.0938 21.0938 16.3718 21.0938 10.5469C21.0938 4.722 16.3718 0 10.5469 0C4.722 0 0 4.722 0 10.5469C0 16.3718 4.722 21.0938 10.5469 21.0938Z",
    fill: "url(#paint0_linear_160_356)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7877 4.6875H8.31113C6.31426 4.6875 4.69238 6.30937 4.69238 8.30625V12.7828C4.69238 14.7797 6.31426 16.4016 8.31113 16.4016H12.7877C14.7846 16.4016 16.4064 14.7797 16.4064 12.7828V8.30625C16.4064 6.30937 14.7846 4.6875 12.7877 4.6875ZM15.0986 12.7875C15.0986 14.0625 14.0627 15.1031 12.783 15.1031H8.30644C7.03144 15.1031 5.99082 14.0672 5.99082 12.7875V8.31094C5.99082 7.03594 7.02676 5.99531 8.30644 5.99531H12.783C14.058 5.99531 15.0986 7.03125 15.0986 8.31094V12.7875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5471 7.55176C8.89707 7.55176 7.55176 8.89707 7.55176 10.5471C7.55176 12.1971 8.89707 13.5424 10.5471 13.5424C12.1971 13.5424 13.5424 12.1971 13.5424 10.5471C13.5424 8.89707 12.1971 7.55176 10.5471 7.55176ZM10.5471 12.3658C9.54395 12.3658 8.72832 11.5502 8.72832 10.5471C8.72832 9.54395 9.54395 8.72832 10.5471 8.72832C11.5502 8.72832 12.3658 9.54395 12.3658 10.5471C12.3658 11.5502 11.5502 12.3658 10.5471 12.3658Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7701 7.88025C14.046 7.83552 14.2335 7.57554 14.1887 7.29958C14.144 7.02362 13.884 6.83618 13.6081 6.88091C13.3321 6.92565 13.1447 7.18562 13.1894 7.46158C13.2341 7.73754 13.4941 7.92499 13.7701 7.88025Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_356",
    x1: 2.5162,
    y1: 18.5775,
    x2: 17.5045,
    y2: 3.58927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0518459,
    stopColor: "#FEDB16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    stopColor: "#FEC125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    stopColor: "#FE983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#FE5F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE2181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.5345248263aeb46f7221b6b841550ab1.svg";
export { ForwardRef as ReactComponent };